export const BASE_URL = 'https://li.quest/v1';
export const DEFAULT_INTEGRATORS_CONFIG = { default: 'exodus' };
export const DEFAULT_FEE = 0.01;
export const DEFAULT_SLIPPAGE = 2;
export const DEFAULT_OPTIONS = {
    gasLimitMultiplier: 0.8,
};
export const CHAIN_ID_TO_NETWORKS = new Map([
    [1, 'ethereum'],
    [137, 'matic'],
    [56, 'bsc'],
    [250, 'fantom'],
    [43_114, 'avalanchec'],
]);
export const NETWORK_TO_CHAIN_ID = new Map([...CHAIN_ID_TO_NETWORKS.entries()].map(([k, v]) => [v, k]));
export const SVC = 'lifi';
export const X_CHAIN_ETH_MIN_AMOUNT_USD = 150;
export const X_CHAIN_MIN_AMOUNT_USD = 50;
export const MIN_AMOUNT_USD = 10;
export const MAX_AMOUNT_USD = 100_000;
